import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import PsContext from "../../context";
import { NoData, upperCase } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import toast from "react-hot-toast";

const AttendanceList = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);
  const [attendanceData, setAttendanceData] = useState([]);
  const [holiday, setHoliday] = useState([]);

  useEffect(() => {
    loadTimeTable();
  }, []);

  const loadTimeTable = () => {
    setLoader(true);
    setHoliday([]);
    setAttendanceData([]);
    const form = new FormData();
    form.append("type", "today");
    form.append("college_uuid", context.user.college_uuid);
    if (props.timeTableDate) form.append("date", props.timeTableDate);
    axios.post(ServiceUrl.STUDENTS.MY_TIME_TABLE, form).then((res) => {
      if (res["data"].status === "1") {
        setAttendanceData(res["data"].data);
      } else {
        if (res["data"].data && res["data"].data > 0) {
          setHoliday(res["data"].data);
        } else {
          console.log(res["data"].message);
          toast.error(res["data"].message || "Error");
          setLoader(false);
          return;
        }
      }
      setLoader(false);
    });
  };

  /*  const leaveType = (lt) => {
    if (["P", "ML", "OD"].includes(upperCase(lt)))
      return <span className="text-success">{upperCase(lt)}</span>;
    if (["A", "LA", "L"].includes(upperCase(lt)))
      return <span className="text-danger">{upperCase(lt)}</span>;
    return <span>-</span>;
  }; */
  const leaveType = (lt) => {
    const leaveStatus = upperCase(lt);
    let statusColor = "";
    let bgColor = "";

    // Determine text and background color based on leave type
    if (["P", "ML", "OD"].includes(leaveStatus)) {
      statusColor = "text-success"; // Green text for present, ML, and OD
      bgColor = "#d4edda"; // Light green background
    } else if (["A", "LA", "L"].includes(leaveStatus)) {
      statusColor = "text-danger"; // Red text for absence types
      bgColor = "#f8d7da"; // Light red background
    } else {
      statusColor = "text-secondary"; // Grey text for unknown status
      bgColor = "#e2e3e5"; // Light grey background
    }

    return (
      <span
        style={{
          display: "inline-block",
          padding: "5px 10px",
          borderRadius: "15px", // Rounded corners
          backgroundColor: bgColor,
          color: statusColor,
          fontWeight: "bold",
          textTransform: "uppercase", // Optional: make text uppercase for consistency
        }}
      >
        {leaveStatus || "-"}
      </span>
    );
  };

  const getAttRows = () => {
    return attendanceData.map((m, i) => (
      <div
        key={i}
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "15px 0",
          margin: "5px 0",
          border: "1px solid #1976d2", // Add border around the row
          borderRadius: "5px",
          background: "#f9f9f9",
        }}
      >
        <div
          style={{
            flex: 1,
            fontWeight: "bold",
            color: "#333",
            textAlign: "center",
            borderRight: "1px solid #ddd", // Border for columns
            padding: "10px",
          }}
        >
          H{i + 1}
        </div>
        <div
          style={{
            flex: 2,
            textAlign: "left",
            borderRight: "1px solid #ddd", // Border for columns
            padding: "10px",
          }}
        >
          <div style={{ fontSize: "14px", color: "#000" }}>
            {m.allocated_subject || "-"}
          </div>
          <small style={{ color: "#666" }}>{m.allocated_teacher || "-"}</small>
        </div>
        <div
          style={{
            flex: 2,
            textAlign: "left",
            borderRight: "1px solid #ddd", // Border for columns
            padding: "10px",
          }}
        >
          <div style={{ fontSize: "14px", color: "#000" }}>
            {m.marked_subject || "-"}
          </div>
          <small style={{ color: "#666" }}>{m.marked_teacher || "-"}</small>
        </div>
        <div
          style={{
            flex: 1,
            textAlign: "center",
            padding: "10px",
          }}
        >
          {leaveType(m.leave_type)}
        </div>
      </div>
    ));
  };

  return (
    <>
      {loader && (
        <div className="text-center" style={{ minHeight: "100px" }}>
          <Spinner animation="border" role="status" />
        </div>
      )}
      {!loader && attendanceData.length > 0 && (
        <div>
          {/* Table Header */}
          <div
            className="ps_app_cls_primary bg-theme"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "15px",
              marginBottom: "10px",
              borderRadius: "10px",
              border: "2px solid #1976d2", // Add a border for distinction
              color: "#fff",
              fontWeight: "bold",
              textTransform: "uppercase",
            }}
          >
            <div
              style={{
                flex: 1,
                textAlign: "center",
                borderRight: "1px solid #fff", // Add column border
                paddingRight: "10px",
              }}
            >
              Hours
            </div>
            <div
              style={{
                flex: 2,
                textAlign: "center",
                borderRight: "1px solid #fff", // Add column border
                paddingRight: "10px",
              }}
            >
              Allocated
            </div>
            <div
              style={{
                flex: 2,
                textAlign: "center",
                borderRight: "1px solid #fff", // Add column border
                paddingRight: "10px",
              }}
            >
              Taken
            </div>
            <div
              style={{
                flex: 1,
                textAlign: "center",
              }}
            >
              Status
            </div>
          </div>

          {/* Attendance Rows */}
          {getAttRows()}
        </div>
      )}
      {!loader && holiday && holiday.holiday_name && (
        <div
          style={{
            color: "#ff4d4f",
            fontWeight: "bold",
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          {holiday.holiday_name}
        </div>
      )}
      {!loader && attendanceData.length < 1 && !holiday.holiday_name && (
        <NoData imgWidth="130px" />
      )}
    </>
  );
};

export default AttendanceList;
